// import React, { useState, useEffect } from "react";
// import orderService from "../../services/orderService";
// import "./MyAccount.css";

// const OrderHistory = () => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [showOrderModal, setShowOrderModal] = useState(false);
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch orders on component mount
//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const fetchOrders = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const response = await orderService.getCustomerOrders();
//       console.log(response.data, "ddd");
//       // Transform backend data to match frontend structure
//       const transformedOrders = response?.data?.map(transformOrder);
//       console.log(transformedOrders, "transformedOrders");
//       setOrders(transformedOrders);
//     } catch (err) {
//       console.error("Error fetching orders:", err);
//       setError(err.response?.data?.message || "Failed to load orders");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Transform backend order data to frontend format
//   const transformOrder = (order) => {
//     return {
//       id: order?.orderNumber || order._id,
//       date: order.createdAt,
//       items: order.items.map((item) => ({
//         name: item.name,
//         quantity: item.quantity,
//         price: item.price,
//         image: item.image,
//         size: item.size || "N/A",
//         color: item.color || "N/A",
//       })),
//       total: order.totalAmount,
//       subtotal: order.subtotal,
//       shipping: order.deliveryFee,
//       status: mapOrderStatus(order.orderStatus),
//       shippingAddress: {
//         name: order.shippingAddress.name,
//         phone: order.shippingAddress.mobile,
//         address: formatAddress(order.shippingAddress),
//       },
//       trackingDetails: buildTrackingDetails(order),
//       trackingNumber: order.trackingNumber,
//       paymentMethod: order.paymentMethod,
//       paymentStatus: order.paymentStatus,
//     };
//   };

//   // Map backend order status to frontend status
//   const mapOrderStatus = (backendStatus) => {
//     const statusMap = {
//       Pending: "confirmed",
//       Confirmed: "confirmed",
//       Processing: "packed",
//       Shipped: "shipped",
//       "Out for Delivery": "shipped",
//       Delivered: "delivered",
//       Cancelled: "cancelled",
//       Returned: "returned",
//     };
//     return statusMap[backendStatus] || "confirmed";
//   };

//   // Format address from backend structure
//   const formatAddress = (address) => {
//     const parts = [
//       address.addressLine1,
//       address.addressLine2,
//       address.landmark,
//       address.city,
//       address.state,
//       address.pincode,
//     ].filter(Boolean);
//     return parts.join(", ");
//   };

//   // Build tracking details from status history
//   const buildTrackingDetails = (order) => {
//     const statusHistory = order.statusHistory || [];

//     const findStatusEntry = (statuses) => {
//       const entry = statusHistory.find((h) => statuses.includes(h.status));
//       return entry
//         ? {
//             date: new Date(entry.timestamp).toLocaleDateString("en-US", {
//               year: "numeric",
//               month: "short",
//               day: "numeric",
//             }),
//             time: new Date(entry.timestamp).toLocaleTimeString("en-US", {
//               hour: "2-digit",
//               minute: "2-digit",
//             }),
//           }
//         : null;
//     };

//     return {
//       confirmed: findStatusEntry(["Pending", "Confirmed"]),
//       packed: findStatusEntry(["Processing"]),
//       shipped: findStatusEntry(["Shipped", "Out for Delivery"]),
//       delivered: order.deliveredAt
//         ? {
//             date: new Date(order.deliveredAt).toLocaleDateString("en-US", {
//               year: "numeric",
//               month: "short",
//               day: "numeric",
//             }),
//             time: new Date(order.deliveredAt).toLocaleTimeString("en-US", {
//               hour: "2-digit",
//               minute: "2-digit",
//             }),
//           }
//         : null,
//     };
//   };

//   const getStatusProgress = (status) => {
//     const statusMap = {
//       confirmed: 25,
//       packed: 50,
//       shipped: 75,
//       delivered: 100,
//       cancelled: 0,
//       returned: 0,
//     };
//     return statusMap[status] || 0;
//   };

//   const getStatusColor = (status) => {
//     const colorMap = {
//       confirmed: "#ffa726",
//       packed: "#42a5f5",
//       shipped: "#ab47bc",
//       delivered: "#66bb6a",
//       cancelled: "#ef5350",
//       returned: "#ff9800",
//     };
//     return colorMap[status] || "#ccc";
//   };

//   const handleViewOrder = async (order) => {
//     try {
//       // Fetch full order details from backend
//       const response = await orderService.getOrderById(order.id);
//       const fullOrder = transformOrder(response.data);
//       setSelectedOrder(fullOrder);
//       setShowOrderModal(true);
//     } catch (err) {
//       console.error("Error fetching order details:", err);
//       setError("Failed to load order details");
//     }
//   };

//   const handleCancelOrder = async (orderId) => {
//     if (!window.confirm("Are you sure you want to cancel this order?")) {
//       return;
//     }

//     try {
//       const reason = prompt("Please provide a reason for cancellation:");
//       if (!reason) return;

//       await orderService.cancelOrder(orderId, reason);

//       // Refresh orders
//       await fetchOrders();
//       setShowOrderModal(false);
//       alert("Order cancelled successfully");
//     } catch (err) {
//       console.error("Error cancelling order:", err);
//       alert(err.response?.data?.message || "Failed to cancel order");
//     }
//   };

//   const handleTrackOrder = async (orderId) => {
//     try {
//       const response = await orderService.getOrderTracking(orderId);
//       // You can show tracking details in a modal or navigate to tracking page
//       console.log("Tracking details:", response.data);
//       alert("Tracking details loaded. Check console for now.");
//     } catch (err) {
//       console.error("Error fetching tracking:", err);
//       alert("Failed to load tracking details");
//     }
//   };

//   const filteredOrders = orders?.filter((order) =>
//     //   order._id.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     order.items.some((item) =>
//       item.name.toLowerCase().includes(searchQuery.toLowerCase())
//     )
//   );

//   if (loading) {
//     return (
//       <div className="order-history-section">
//         <div className="loading-container">
//           <div className="spinner"></div>
//           <p>Loading your orders...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="order-history-section">
//         <div className="error-container">
//           <svg
//             width="60"
//             height="60"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="#ef5350"
//             strokeWidth="2"
//           >
//             <circle cx="12" cy="12" r="10" />
//             <line x1="12" y1="8" x2="12" y2="12" />
//             <line x1="12" y1="16" x2="12.01" y2="16" />
//           </svg>
//           <h3>Error loading orders</h3>
//           <p>{error}</p>
//           <button className="btn-primary" onClick={fetchOrders}>
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="order-history-section">
//       <div className="section-header">
//         <div>
//           <h2 className="section-title">Order History</h2>
//           <p className="section-subtitle">Track and manage your orders</p>
//         </div>
//       </div>

//       {/* Search Bar */}
//       <div className="search-bar-container">
//         <div className="search-input-wrapper">
//           <svg
//             className="search-icon"
//             width="20"
//             height="20"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//           >
//             <circle cx="11" cy="11" r="8" />
//             <path d="m21 21-4.35-4.35" />
//           </svg>
//           <input
//             type="text"
//             placeholder="Search by order ID or product name..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             className="search-input"
//           />
//           {searchQuery && (
//             <button className="clear-search" onClick={() => setSearchQuery("")}>
//               <svg
//                 width="18"
//                 height="18"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//               >
//                 <line x1="18" y1="6" x2="6" y2="18" />
//                 <line x1="6" y1="6" x2="18" y2="18" />
//               </svg>
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Orders List */}
//       <div className="orders-list">
//         {filteredOrders?.length > 0 ? (
//           filteredOrders.map((order) => (
//             <div key={order.id} className="order-card">
//               <div className="order-header">
//                 <div className="order-info">
//                   <h3 className="order-id">{order.id}</h3>
//                   <p className="order-date">
//                     Placed on{" "}
//                     {new Date(order.date).toLocaleDateString("en-US", {
//                       year: "numeric",
//                       month: "long",
//                       day: "numeric",
//                     })}
//                   </p>
//                 </div>
//                 <div className="order-total">
//                   <span className="total-label">Total</span>
//                   <span className="total-amount">₹{order.total}</span>
//                 </div>
//               </div>

//               {/* Order Items */}
//               <div className="order-items">
//                 {order.items.map((item, index) => (
//                   <div key={index} className="order-item">
//                     <span className="item-name">
//                       {item.name} x {item.quantity}
//                     </span>
//                     <span className="item-price">₹{item.price}</span>
//                   </div>
//                 ))}
//               </div>

//               {/* Progress Bar */}
//               <div className="order-progress">
//                 <div className="progress-bar-container">
//                   <div
//                     className="progress-bar-fill"
//                     style={{
//                       width: `${getStatusProgress(order.status)}%`,
//                       backgroundColor: getStatusColor(order.status),
//                     }}
//                   ></div>
//                 </div>
//               </div>

//               {/* Order Status Timeline */}
//               <div className="order-timeline">
//                 <div
//                   className={`timeline-step ${
//                     order.trackingDetails.confirmed ? "completed" : ""
//                   } ${order.status === "confirmed" ? "active" : ""}`}
//                 >
//                   <div className="step-icon">
//                     <svg
//                       width="20"
//                       height="20"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <polyline points="20 6 9 17 4 12" />
//                     </svg>
//                   </div>
//                   <div className="step-content">
//                     <p className="step-label">Confirmed</p>
//                     {order.trackingDetails.confirmed && (
//                       <p className="step-date">
//                         {order.trackingDetails.confirmed.date}
//                         <span className="step-time">
//                           {order.trackingDetails.confirmed.time}
//                         </span>
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 <div
//                   className={`timeline-step ${
//                     order.trackingDetails.packed ? "completed" : ""
//                   } ${order.status === "packed" ? "active" : ""}`}
//                 >
//                   <div className="step-icon">
//                     <svg
//                       width="20"
//                       height="20"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
//                       <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
//                       <line x1="12" y1="22.08" x2="12" y2="12" />
//                     </svg>
//                   </div>
//                   <div className="step-content">
//                     <p className="step-label">Packed</p>
//                     {order.trackingDetails.packed && (
//                       <p className="step-date">
//                         {order.trackingDetails.packed.date}
//                         <span className="step-time">
//                           {order.trackingDetails.packed.time}
//                         </span>
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 <div
//                   className={`timeline-step ${
//                     order.trackingDetails.shipped ? "completed" : ""
//                   } ${order.status === "shipped" ? "active" : ""}`}
//                 >
//                   <div className="step-icon">
//                     <svg
//                       width="20"
//                       height="20"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <rect x="1" y="3" width="15" height="13" />
//                       <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
//                       <circle cx="5.5" cy="18.5" r="2.5" />
//                       <circle cx="18.5" cy="18.5" r="2.5" />
//                     </svg>
//                   </div>
//                   <div className="step-content">
//                     <p className="step-label">Shipped</p>
//                     {order.trackingDetails.shipped && (
//                       <p className="step-date">
//                         {order.trackingDetails.shipped.date}
//                         <span className="step-time">
//                           {order.trackingDetails.shipped.time}
//                         </span>
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 <div
//                   className={`timeline-step ${
//                     order.trackingDetails.delivered ? "completed" : ""
//                   } ${order.status === "delivered" ? "active" : ""}`}
//                 >
//                   <div className="step-icon">
//                     <svg
//                       width="20"
//                       height="20"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
//                       <polyline points="9 22 9 12 15 12 15 22" />
//                     </svg>
//                   </div>
//                   <div className="step-content">
//                     <p className="step-label">Delivered</p>
//                     {order.trackingDetails.delivered && (
//                       <p className="step-date">
//                         {order.trackingDetails.delivered.date}
//                         <span className="step-time">
//                           {order.trackingDetails.delivered.time}
//                         </span>
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="order-actions">
//                 <button
//                   className="btn-secondary"
//                   onClick={() => handleViewOrder(order)}
//                 >
//                   View Details
//                 </button>
//                 {order.status === "delivered" && (
//                   <button className="btn-primary">Rate & Review</button>
//                 )}
//                 {order.status !== "delivered" &&
//                   order.status !== "cancelled" && (
//                     <>
//                       <button
//                         className="btn-secondary"
//                         onClick={() => handleTrackOrder(order.id)}
//                       >
//                         Track Order
//                       </button>
//                       <button
//                         className="btn-danger"
//                         onClick={() => handleCancelOrder(order.id)}
//                       >
//                         Cancel Order
//                       </button>
//                     </>
//                   )}
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="no-orders">
//             <svg
//               width="80"
//               height="80"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="1.5"
//             >
//               <circle cx="12" cy="12" r="10" />
//               <path d="M16 16s-1.5-2-4-2-4 2-4 2" />
//               <line x1="9" y1="9" x2="9.01" y2="9" />
//               <line x1="15" y1="9" x2="15.01" y2="9" />
//             </svg>
//             <h3>No orders found</h3>
//             <p>
//               {searchQuery
//                 ? "Try adjusting your search criteria"
//                 : "You haven't placed any orders yet"}
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Order Details Modal */}
//       {showOrderModal && selectedOrder && (
//         <div className="modal-overlay" onClick={() => setShowOrderModal(false)}>
//           <div
//             className="modal-content order-modal-content"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-header">
//               <h3 className="modal-title">Order Details</h3>
//               <button
//                 className="modal-close"
//                 onClick={() => setShowOrderModal(false)}
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <line x1="18" y1="6" x2="6" y2="18" />
//                   <line x1="6" y1="6" x2="18" y2="18" />
//                 </svg>
//               </button>
//             </div>

//             <div className="order-modal-body">
//               {/* Order Info */}
//               <div className="modal-order-info">
//                 <div className="info-row">
//                   <span className="info-label">Order ID:</span>
//                   <span className="info-value">{selectedOrder.id}</span>
//                 </div>
//                 <div className="info-row">
//                   <span className="info-label">Order Date:</span>
//                   <span className="info-value">
//                     {new Date(selectedOrder.date).toLocaleDateString("en-US", {
//                       year: "numeric",
//                       month: "long",
//                       day: "numeric",
//                     })}
//                   </span>
//                 </div>
//                 <div className="info-row">
//                   <span className="info-label">Status:</span>
//                   <span
//                     className={`status-badge status-${selectedOrder.status}`}
//                   >
//                     {selectedOrder.status.charAt(0).toUpperCase() +
//                       selectedOrder.status.slice(1)}
//                   </span>
//                 </div>
//                 {selectedOrder.trackingNumber && (
//                   <div className="info-row">
//                     <span className="info-label">Tracking Number:</span>
//                     <span className="info-value">
//                       {selectedOrder.trackingNumber}
//                     </span>
//                   </div>
//                 )}
//                 <div className="info-row">
//                   <span className="info-label">Payment Method:</span>
//                   <span className="info-value">
//                     {selectedOrder.paymentMethod}
//                   </span>
//                 </div>
//                 <div className="info-row">
//                   <span className="info-label">Payment Status:</span>
//                   <span
//                     className={`status-badge status-${selectedOrder.paymentStatus.toLowerCase()}`}
//                   >
//                     {selectedOrder.paymentStatus}
//                   </span>
//                 </div>
//               </div>

//               {/* Shipping Address */}
//               <div className="modal-section">
//                 <h4 className="modal-section-title">Shipping Address</h4>
//                 <div className="shipping-address-box">
//                   <p className="address-name">
//                     {selectedOrder.shippingAddress.name}
//                   </p>
//                   <p className="address-phone">
//                     {selectedOrder.shippingAddress.phone}
//                   </p>
//                   <p className="address-text">
//                     {selectedOrder.shippingAddress.address}
//                   </p>
//                 </div>
//               </div>

//               {/* Order Items */}
//               <div className="modal-section">
//                 <h4 className="modal-section-title">Order Items</h4>
//                 <div className="modal-items-list">
//                   {selectedOrder.items.map((item, index) => (
//                     <div key={index} className="modal-item">
//                       <img
//                         src={item.image}
//                         alt={item.name}
//                         className="modal-item-image"
//                       />
//                       <div className="modal-item-details">
//                         <h5 className="modal-item-name">{item.name}</h5>
//                         <p className="modal-item-meta">
//                           Size: {item.size} | Color: {item.color}
//                         </p>
//                         <p className="modal-item-qty">
//                           Quantity: {item.quantity}
//                         </p>
//                       </div>
//                       <div className="modal-item-price">₹{item.price}</div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Order Summary */}
//               <div className="modal-section">
//                 <h4 className="modal-section-title">Order Summary</h4>
//                 <div className="order-summary">
//                   <div className="summary-row">
//                     <span>Subtotal:</span>
//                     <span>₹{selectedOrder.subtotal}</span>
//                   </div>
//                   <div className="summary-row">
//                     <span>Shipping:</span>
//                     <span>
//                       {selectedOrder.shipping === 0
//                         ? "FREE"
//                         : `₹${selectedOrder.shipping}`}
//                     </span>
//                   </div>
//                   <div className="summary-row total-row">
//                     <span>Total:</span>
//                     <span>₹{selectedOrder.total}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrderHistory;

import { useState, useEffect } from "react";
import orderService from "../../services/orderService";
import "./MyAccount.css";

const OrderHistory = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch orders on component mount
  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await orderService.getCustomerOrders();

      console.log("Response:", response);

      if (response?.success && response?.data) {
        const transformedOrders = response.data.map(transformOrder);
        console.log("Transformed orders:", transformedOrders);
        setOrders(transformedOrders);
      } else {
        setOrders([]);
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      setError(err.response?.data?.message || "Failed to load orders");
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  // Transform backend order data to frontend format
  const transformOrder = (order) => {
    return {
      id: order._id, // Use _id as fallback since orderNumber might not exist yet
      orderNumber: order.orderNumber || order._id,
      date: order.createdAt,
      items: order.items.map((item) => ({
        name: item.name,
        quantity: item.quantity,
        price: item.price,
        image:
          item.image ||
          item.product?.images?.[0]?.url ||
          "https://via.placeholder.com/100",
        size: item.size || "N/A",
        color: item.color || "N/A",
      })),
      total: order.totalAmount,
      subtotal: order.subtotal,
      shipping: order.deliveryFee,
      tax: order.tax || 0,
      discount: order.discount || 0,
      status: mapOrderStatus(order.orderStatus),
      shippingAddress: order.shippingAddress
        ? {
            name: order.shippingAddress.name || "N/A",
            phone: order.shippingAddress.mobile || order.shippingAddress.phone || "N/A",
            address: formatAddress(order.shippingAddress),
          }
        : { name: "N/A", phone: "N/A", address: "N/A" },
      trackingDetails: buildTrackingDetails(order),
      trackingNumber: order.trackingNumber || null,
      paymentMethod: order.paymentMethod,
      paymentStatus: order.paymentStatus,
      cancellationReason: order.cancellationReason || null,
      rawStatus: order.orderStatus, // Keep original status for backend calls
    };
  };

  // Map backend order status to frontend status
  const mapOrderStatus = (backendStatus) => {
    const statusMap = {
      Pending: "confirmed",
      Confirmed: "confirmed",
      Processing: "packed",
      Shipped: "shipped",
      "Out for Delivery": "shipped",
      Delivered: "delivered",
      Cancelled: "cancelled",
      Returned: "returned",
    };
    return statusMap[backendStatus] || "confirmed";
  };

  // Format address from backend structure
  const formatAddress = (address) => {
    const parts = [
      address.addressLine1,
      address.addressLine2,
      address.landmark,
      address.city,
      address.state,
      address.pincode,
    ].filter(Boolean);
    return parts.join(", ");
  };

  // Build tracking details from status history
  const buildTrackingDetails = (order) => {
    const statusHistory = order.statusHistory || [];

    const findStatusEntry = (statuses) => {
      const entry = statusHistory.find((h) =>
        statuses.includes(h.status || h.orderStatus)
      );
      return entry
        ? {
            date: new Date(entry.timestamp).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            }),
            time: new Date(entry.timestamp).toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
            }),
          }
        : null;
    };

    return {
      confirmed: findStatusEntry(["Pending", "Confirmed"]),
      packed: findStatusEntry(["Processing"]),
      shipped: findStatusEntry(["Shipped", "Out for Delivery"]),
      delivered: order.deliveredAt
        ? {
            date: new Date(order.deliveredAt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            }),
            time: new Date(order.deliveredAt).toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
            }),
          }
        : null,
    };
  };

  const getStatusProgress = (status) => {
    const statusMap = {
      confirmed: 25,
      packed: 50,
      shipped: 75,
      delivered: 100,
      cancelled: 0,
      returned: 0,
    };
    return statusMap[status] || 0;
  };

  const getStatusColor = (status) => {
    const colorMap = {
      confirmed: "#ffa726",
      packed: "#42a5f5",
      shipped: "#ab47bc",
      delivered: "#66bb6a",
      cancelled: "#ef5350",
      returned: "#ff9800",
    };
    return colorMap[status] || "#ccc";
  };

  const handleViewOrder = async (order) => {
    try {
      // Fetch full order details from backend
      const response = await orderService.getOrderById(order.id);

      if (response?.success && response?.data) {
        const fullOrder = transformOrder(response.data);
        setSelectedOrder(fullOrder);
        setShowOrderModal(true);
      } else {
        setError("Failed to load order details");
      }
    } catch (err) {
      console.error("Error fetching order details:", err);
      setError("Failed to load order details");
    }
  };

  const handleCancelOrder = async (orderId) => {
    if (!window.confirm("Are you sure you want to cancel this order?")) {
      return;
    }

    try {
      const reason = prompt("Please provide a reason for cancellation:");
      if (!reason || reason.trim() === "") {
        alert("Cancellation reason is required");
        return;
      }

      const response = await orderService.cancelOrder(orderId, reason);

      if (response?.success) {
        // Refresh orders
        await fetchOrders();
        setShowOrderModal(false);
        alert("Order cancelled successfully");
      } else {
        alert(response?.message || "Failed to cancel order");
      }
    } catch (err) {
      console.error("Error cancelling order:", err);
      alert(err.response?.data?.message || "Failed to cancel order");
    }
  };

  const handleTrackOrder = async (orderId) => {
    try {
      const response = await orderService.getOrderTracking(orderId);

      if (response?.success && response?.data) {
        // Show tracking details in alert for now
        const trackingInfo = `
Order Number: ${response.data.orderNumber}
Current Status: ${response.data.currentStatus}
${
  response.data.trackingNumber
    ? `Tracking Number: ${response.data.trackingNumber}`
    : ""
}
${
  response.data.shippedAt
    ? `Shipped At: ${new Date(response.data.shippedAt).toLocaleString()}`
    : ""
}
${
  response.data.deliveredAt
    ? `Delivered At: ${new Date(response.data.deliveredAt).toLocaleString()}`
    : ""
}
        `;
        alert(trackingInfo);
      }
    } catch (err) {
      console.error("Error fetching tracking:", err);
      alert("Failed to load tracking details");
    }
  };

  const filteredOrders = orders.filter(
    (order) =>
      order.orderNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.items.some((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
  );

  if (loading) {
    return (
      <div className="order-history-section">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading your orders...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="order-history-section">
        <div className="error-container">
          <svg
            width="60"
            height="60"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ef5350"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <h3>Error loading orders</h3>
          <p>{error}</p>
          <button className="btn-primary" onClick={fetchOrders}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="order-history-section">
      <div className="section-header">
        <div>
          <h2 className="section-title">Order History</h2>
          <p className="section-subtitle">Track and manage your orders</p>
        </div>
      </div>

      {/* Search Bar */}
      <div className="search-bar-container">
        <div className="search-input-wrapper">
          <svg
            className="search-icon"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
          <input
            type="text"
            placeholder="Search by order ID or product name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
          {searchQuery && (
            <button className="clear-search" onClick={() => setSearchQuery("")}>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          )}
        </div>
      </div>

      {/* Orders List */}
      <div className="orders-list">
        {filteredOrders.length > 0 ? (
          filteredOrders.map((order) => (
            <div key={order.id} className="order-card">
              <div className="order-header">
                <div className="order-info">
                  <h3 className="order-id">Order #{order.orderNumber}</h3>
                  <p className="order-date">
                    Placed on{" "}
                    {new Date(order.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                </div>
                <div className="order-total">
                  <span className="total-label">Total</span>
                  <span className="total-amount">₹{order.total}</span>
                </div>
              </div>

              {/* Order Items */}
              <div className="order-items">
                {order.items.map((item, index) => (
                  <div key={index} className="order-item">
                    <span className="item-name">
                      {item.name} x {item.quantity}
                    </span>
                    <span className="item-price">
                      ₹{item.price * item.quantity}
                    </span>
                  </div>
                ))}
              </div>

              {/* Progress Bar */}
              <div className="order-progress">
                <div className="progress-bar-container">
                  <div
                    className="progress-bar-fill"
                    style={{
                      width: `${getStatusProgress(order.status)}%`,
                      backgroundColor: getStatusColor(order.status),
                    }}
                  ></div>
                </div>
              </div>

              {/* Order Status Timeline */}
              <div className="order-timeline">
                <div
                  className={`timeline-step ${
                    order.trackingDetails.confirmed ? "completed" : ""
                  } ${order.status === "confirmed" ? "active" : ""}`}
                >
                  <div className="step-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <div className="step-content">
                    <p className="step-label">Confirmed</p>
                    {order.trackingDetails.confirmed && (
                      <p className="step-date">
                        {order.trackingDetails.confirmed.date}
                        <span className="step-time">
                          {order.trackingDetails.confirmed.time}
                        </span>
                      </p>
                    )}
                  </div>
                </div>

                <div
                  className={`timeline-step ${
                    order.trackingDetails.packed ? "completed" : ""
                  } ${order.status === "packed" ? "active" : ""}`}
                >
                  <div className="step-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                      <line x1="12" y1="22.08" x2="12" y2="12" />
                    </svg>
                  </div>
                  <div className="step-content">
                    <p className="step-label">Packed</p>
                    {order.trackingDetails.packed && (
                      <p className="step-date">
                        {order.trackingDetails.packed.date}
                        <span className="step-time">
                          {order.trackingDetails.packed.time}
                        </span>
                      </p>
                    )}
                  </div>
                </div>

                <div
                  className={`timeline-step ${
                    order.trackingDetails.shipped ? "completed" : ""
                  } ${order.status === "shipped" ? "active" : ""}`}
                >
                  <div className="step-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <rect x="1" y="3" width="15" height="13" />
                      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                      <circle cx="5.5" cy="18.5" r="2.5" />
                      <circle cx="18.5" cy="18.5" r="2.5" />
                    </svg>
                  </div>
                  <div className="step-content">
                    <p className="step-label">Shipped</p>
                    {order.trackingDetails.shipped && (
                      <p className="step-date">
                        {order.trackingDetails.shipped.date}
                        <span className="step-time">
                          {order.trackingDetails.shipped.time}
                        </span>
                      </p>
                    )}
                  </div>
                </div>

                <div
                  className={`timeline-step ${
                    order.trackingDetails.delivered ? "completed" : ""
                  } ${order.status === "delivered" ? "active" : ""}`}
                >
                  <div className="step-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                      <polyline points="9 22 9 12 15 12 15 22" />
                    </svg>
                  </div>
                  <div className="step-content">
                    <p className="step-label">Delivered</p>
                    {order.trackingDetails.delivered && (
                      <p className="step-date">
                        {order.trackingDetails.delivered.date}
                        <span className="step-time">
                          {order.trackingDetails.delivered.time}
                        </span>
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="order-actions">
                <button
                  className="btn-secondary"
                  onClick={() => handleViewOrder(order)}
                >
                  View Details
                </button>
                {order.status === "delivered" && (
                  <button className="btn-primary">Rate & Review</button>
                )}
                {order.status !== "delivered" &&
                  order.status !== "cancelled" && (
                    <>
                      {order.trackingNumber && (
                        <button
                          className="btn-secondary"
                          onClick={() => handleTrackOrder(order.id)}
                        >
                          Track Order
                        </button>
                      )}
                      <button
                        className="btn-danger"
                        onClick={() => handleCancelOrder(order.id)}
                      >
                        Cancel Order
                      </button>
                    </>
                  )}
              </div>
            </div>
          ))
        ) : (
          <div className="no-orders">
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M16 16s-1.5-2-4-2-4 2-4 2" />
              <line x1="9" y1="9" x2="9.01" y2="9" />
              <line x1="15" y1="9" x2="15.01" y2="9" />
            </svg>
            <h3>No orders found</h3>
            <p>
              {searchQuery
                ? "Try adjusting your search criteria"
                : "You haven't placed any orders yet"}
            </p>
          </div>
        )}
      </div>

      {/* Order Details Modal */}
      {showOrderModal && selectedOrder && (
        <div className="modal-overlay" onClick={() => setShowOrderModal(false)}>
          <div
            className="modal-content order-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3 className="modal-title">Order Details</h3>
              <button
                className="modal-close"
                onClick={() => setShowOrderModal(false)}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            <div className="order-modal-body">
              {/* Order Info */}
              <div className="modal-order-info">
                <div className="info-row">
                  <span className="info-label">Order ID:</span>
                  <span className="info-value">
                    #{selectedOrder.orderNumber}
                  </span>
                </div>
                <div className="info-row">
                  <span className="info-label">Order Date:</span>
                  <span className="info-value">
                    {new Date(selectedOrder.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </span>
                </div>
                <div className="info-row">
                  <span className="info-label">Status:</span>
                  <span
                    className={`status-badge status-${selectedOrder.status}`}
                  >
                    {selectedOrder.status.charAt(0).toUpperCase() +
                      selectedOrder.status.slice(1)}
                  </span>
                </div>
                {selectedOrder.trackingNumber && (
                  <div className="info-row">
                    <span className="info-label">Tracking Number:</span>
                    <span className="info-value">
                      {selectedOrder.trackingNumber}
                    </span>
                  </div>
                )}
                <div className="info-row">
                  <span className="info-label">Payment Method:</span>
                  <span className="info-value">
                    {selectedOrder.paymentMethod}
                  </span>
                </div>
                <div className="info-row">
                  <span className="info-label">Payment Status:</span>
                  <span
                    className={`status-badge status-${selectedOrder.paymentStatus.toLowerCase()}`}
                  >
                    {selectedOrder.paymentStatus}
                  </span>
                </div>
                {selectedOrder.cancellationReason && (
                  <div className="info-row">
                    <span className="info-label">Cancellation Reason:</span>
                    <span className="info-value">
                      {selectedOrder.cancellationReason}
                    </span>
                  </div>
                )}
              </div>

              {/* Shipping Address */}
              <div className="modal-section">
                <h4 className="modal-section-title">Shipping Address</h4>
                <div className="shipping-address-box">
                  <p className="address-name">
                    {selectedOrder.shippingAddress.name}
                  </p>
                  <p className="address-phone">
                    {selectedOrder.shippingAddress.phone}
                  </p>
                  <p className="address-text">
                    {selectedOrder.shippingAddress.address}
                  </p>
                </div>
              </div>

              {/* Order Items */}
              <div className="modal-section">
                <h4 className="modal-section-title">Order Items</h4>
                <div className="modal-items-list">
                  {selectedOrder.items.map((item, index) => (
                    <div key={index} className="modal-item">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="modal-item-image"
                      />
                      <div className="modal-item-details">
                        <h5 className="modal-item-name">{item.name}</h5>
                        <p className="modal-item-meta">Size: {item.size}</p>
                        <p className="modal-item-qty">
                          Quantity: {item.quantity}
                        </p>
                      </div>
                      <div className="modal-item-price">
                        ₹{item.price * item.quantity}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Order Summary */}
              <div className="modal-section">
                <h4 className="modal-section-title">Order Summary</h4>
                <div className="order-summary">
                  <div className="summary-row">
                    <span>Subtotal:</span>
                    <span>₹{selectedOrder.subtotal}</span>
                  </div>
                  <div className="summary-row">
                    <span>Shipping:</span>
                    <span>
                      {selectedOrder.shipping === 0
                        ? "FREE"
                        : `₹${selectedOrder.shipping}`}
                    </span>
                  </div>
                  {selectedOrder.discount > 0 && (
                    <div className="summary-row">
                      <span>Discount:</span>
                      <span style={{ color: "#52c41a" }}>
                        -₹{selectedOrder.discount}
                      </span>
                    </div>
                  )}
                  {selectedOrder.tax > 0 && (
                    <div className="summary-row">
                      <span>Tax:</span>
                      <span>₹{selectedOrder.tax}</span>
                    </div>
                  )}
                  <div className="summary-row total-row">
                    <span>Total:</span>
                    <span>₹{selectedOrder.total}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderHistory;
